module.exports = __webpack_public_path__ + "static/media/EW-RnR-banner.a43b9573.svg";